import type { DependencyType } from '@/lib/api/types/items';

export { DependencyType } from '@/lib/api/types/items';

export const SchedulingValidation = {
  MissingTeam: 'MISSING_TEAM',
  EmptyTeam: 'EMPTY_TEAM',
  NoAvailability: 'NO_AVAILABILITY',
  TeamUnavailable: 'TEAM_UNAVAILABLE',
  MissingEstimation: 'MISSING_ESTIMATION',
  InvalidTargetDates: 'INVALID_TARGET_DATES',
  ItemIsDone: 'ITEM_IS_DONE',
  ParentUnschedulable: 'PARENT_UNSCHEDULABLE',
  DependencyUnschedulable: 'DEPENDENCY_UNSCHEDULABLE',
  CircularDependency: 'CIRCULAR_DEPENDENCY',
  OutsideCalendarLimits: 'OUTSIDE_CALENDAR_LIMITS',
} as const;

export type SchedulingValidation = (typeof SchedulingValidation)[keyof typeof SchedulingValidation];

export const TIMELINE_ITEM_IMPUTED_FIELD = {
  ESTIMATION: 'ESTIMATION',
  TEAM: 'TEAM',
} as const;

export type TimelineItemImputedField =
  (typeof TIMELINE_ITEM_IMPUTED_FIELD)[keyof typeof TIMELINE_ITEM_IMPUTED_FIELD];

export interface ScenarioItem {
  organizationId: number;
  scenarioId: number;
  itemId: number;
  teamId: number | null;
  targetStartDateTime: string | null;
  targetFinishDateTime: string | null;
  estimationId: number | null;
  priority: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  schedulingValidations: SchedulingValidation[] | null;
  imputedFields: TimelineItemImputedField[] | null;
}

export interface ScenarioItemPatchRequest {
  teamId?: number | null;
  estimationId?: number | null;
  beforeId?: number;
  afterId?: number;
}

export interface ScenarioItemMetrics {
  expectedStart: string;
  expectedFinish: string;
  latestFinishDate: string;
  totalWorkItemsCount: number;
  plannedWorkItemsCount: number;
}

export interface TimeLineDataSet {
  itemId: number;
  parentId?: number;
  satisfiesPlanFinishDate: boolean;
  hasChildrenOutsidePlanFinishDate: boolean;
}

export interface TimelineItemItem {
  itemId: number;
  name: string;
  itemTypeId: number;
  statusId: number;
  parentId: number | null;
  dependencies: TimelineItemItemDependency[];
  isDeletedInItemStore: boolean;
}

export interface TimelineItemItemDependency {
  dependencyType: DependencyType;
  dependencyItemId: number;
}

export interface TimelineItem {
  scenarioItem: ScenarioItem;
  item: TimelineItemItem;
  scenarioItemMetrics: ScenarioItemMetrics | null;
}
